<template>
	<div ref="house" v-parallax-fit="parallax" class="house">
		<a target="_blank"
			href="https://www.freep.com/in-depth/news/investigations/2019/03/14/wayne-county-land-bank-action-before-auction/2975525002/"><img
				v-tooltip="{ content: 'Click to view', placement: 'top', triggers: ['hover'] }"
				src="/themes/rise-theme/dist/images/estate/character-view/ozzie/21_NewspaperArticle@2x.png" alt=""></a>
	</div>
</template>

<script>
import { store } from '../../store';
export default {
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/ozzie/4.srt',
				'es': '/themes/rise-theme/resources/assets/audio/ozzie/4_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 25000,
					end: 30800,
					fromStyle: { transform: 'translateY(-500%) rotate(-3deg)' },
					toStyle: { transform: 'translateY(0%) rotate(-3deg)' },
					easing: 'linear'
				},
				{
					start: 31200,
					end: 35000,
					fromStyle: { transform: 'translateY(0%) rotate(-3deg)' },
					toStyle: { transform: 'translateY(500%) rotate(45deg)' },
					easing: 'linear'
				}
			]
		}
	},
	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/ozzie/OZZIE_PART5_010723.mp3';

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateY(0%) rotate(-3deg)') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
					this.$evidence.value = null;
					this.$readMore.value = '';
				}
			});
		});

		this.mutationObserver.observe(this.$refs.house, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	}
}
</script>

<style lang="scss" scoped>
.house {
	position: absolute;
	top: 0;
	left: 0;
	min-width: 800px;
	transition: all 0.1s linear;
	margin-left: -100px;
	margin-top: 20px;
	transition: 0.3s;
}

@media screen and (max-width: 1600px) {
	.house {
		min-width: 700px;
		margin-left: -50px;
	}
}

@media screen and (max-width: 991px) {
	.house {
		min-width: 550px;
		margin-left: -50px;
	}
}

@media screen and (max-width: 650px) {
	.house {
		min-width: 350px;
		margin-left: -30px;
	}
}</style>
